import './ReviewModal.scss';
import { Modal, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { api } from '../../../utils/api';

const CATEGORIES = ['Performing', 'Recording', 'Teaching', 'Production', 'Composition', 'Management', 'Other'];

export default function ReviewModal({ candidate, onClose, onReviewed }) {
  const [form, setForm] = useState({
    final_title:     '',
    final_summary:   '',
    final_category:  '',
    final_location:  '',
    final_budget:    '',
    reviewer_reason: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (candidate) {
      setForm({
        final_title:     candidate.final_title    || '',
        final_summary:   candidate.final_summary  || '',
        final_category:  candidate.final_category || '',
        final_location:  candidate.final_location || '',
        final_budget:    candidate.final_budget != null ? String(candidate.final_budget) : '',
        reviewer_reason: '',
      });
    }
  }, [candidate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const submit = async (decision) => {
    setSaving(true);
    try {
      const payload = {
        reviewer_decision: decision,
        reviewer_reason:   form.reviewer_reason || null,
        final_title:       form.final_title    || null,
        final_summary:     form.final_summary  || null,
        final_category:    form.final_category || null,
        final_location:    form.final_location || null,
        final_budget:      form.final_budget !== '' ? parseInt(form.final_budget, 10) : null,
      };
      const { data } = await api.patch(`/facebook-candidates/${candidate.id}`, payload);
      onReviewed(data, decision);
      onClose();
    } catch (err) {
      console.error('Review failed:', err);
    } finally {
      setSaving(false);
    }
  };

  if (!candidate) return null;

  const confidence = candidate.llm_confidence != null
    ? `${Math.round(candidate.llm_confidence * 100)}%`
    : '—';

  const badgeValue = candidate.llm_recommendation;
  const badgeClass = ['approve', 'review', 'reject'].includes(badgeValue)
    ? `fb-badge fb-badge--${badgeValue}`
    : 'fb-badge';

  return (
    <Modal show={!!candidate} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="review-modal__title">Review Candidate #{candidate.id}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="review-modal__meta">
          <span className={badgeClass}>{badgeValue || '—'}</span>
          <span className="review-modal__meta-item">
            Confidence: <strong>{confidence}</strong>
          </span>
          {candidate.facebook_group && (
            <span className="review-modal__meta-item">
              Group: <strong>{candidate.facebook_group}</strong>
            </span>
          )}
          {candidate.author && (
            <span className="review-modal__meta-item">
              Author: <strong>{candidate.author}</strong>
            </span>
          )}
        </div>

        <div className="review-modal__raw">
          {candidate.original_raw_text}
        </div>

        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="review-modal__label">Job Title</Form.Label>
            <Form.Control
              name="final_title"
              value={form.final_title}
              onChange={handleChange}
              placeholder="e.g. Bassist for indie rock band"
              size="sm"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="review-modal__label">Summary</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="final_summary"
              value={form.final_summary}
              onChange={handleChange}
              placeholder="2–3 sentence description for the job board"
              size="sm"
            />
          </Form.Group>

          <div className="review-modal__grid">
            <Form.Group>
              <Form.Label className="review-modal__label">Category</Form.Label>
              <Form.Select name="final_category" value={form.final_category} onChange={handleChange} size="sm">
                <option value="">— select —</option>
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label className="review-modal__label">Location</Form.Label>
              <Form.Control
                name="final_location"
                value={form.final_location}
                onChange={handleChange}
                placeholder="City, State or Remote"
                size="sm"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label className="review-modal__label">Budget (USD)</Form.Label>
              <Form.Control
                type="number"
                name="final_budget"
                value={form.final_budget}
                onChange={handleChange}
                placeholder="0"
                min={0}
                size="sm"
              />
            </Form.Group>
          </div>

          <Form.Group>
            <Form.Label className="review-modal__label">Reason (optional)</Form.Label>
            <Form.Control
              name="reviewer_reason"
              value={form.reviewer_reason}
              onChange={handleChange}
              placeholder="Why are you approving / rejecting this?"
              size="sm"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="review-modal__footer">
        <button className="ppy-btn ppy-btn-secondary" onClick={() => submit('skipped')} disabled={saving}>
          Skip
        </button>
        <button className="ppy-btn ppy-btn-primary" onClick={() => submit('rejected')} disabled={saving}>
          Reject
        </button>
        <button className="ppy-btn review-modal__btn--approve" onClick={() => submit('approved')} disabled={saving}>
          Approve
        </button>
      </Modal.Footer>
    </Modal>
  );
}
